import * as React from 'react';
import { UnifyStyleContextProvider } from 'src/styles/context/unifyStyleContext';

/**
 * A Theme utility provider that can be used to wrap UI roots that should
 * render using legacy Web Skin Dart theming when nested inside a Unify
 * theme context.
 *
 * @access public
 *
 * @see NestedUnifyThemeProvider
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export const WsdThemeProvider: React.FC<React.PropsWithChildren<{}>> = (
  props
) => {
  const { children } = props;

  return (
    <UnifyStyleContextProvider value={{ legacyWsdStyleSupport: true }}>
      {children}
    </UnifyStyleContextProvider>
  );
};

export default WsdThemeProvider;
